/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import currencyFormatter from 'currency-formatter';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

// "Dumb" Currency input
//
// Basically, just a text field with a currency symbol prefix/suffix, and some input normalization to an integer
// cents value
export class CurrencyInput extends React.Component {
        static initClass() {
          this.propTypes = {
            // Currency identifier, as a string ("usd")
            currency: PropTypes.string,
            // Initial value as cents
            value: PropTypes.number,
            // Change callback, takes arguments: (event, cents)
            onChange: PropTypes.func,
            // Placeholder currency value as cents (will be formatted automatically)
            placeholderValue: PropTypes.number,
            // Placeholder string
            placeholder: PropTypes.string,
            // Is input disabled
            disabled: PropTypes.bool
          };
  
          this.defaultProps = {
            currency: 'usd',
            value: null,
            disabled: false,
            onChange() {}
          };
  
          // Flag indicating the user has interacted with this input
          this.prototype.dirty = false;
  
          // The raw cents value currently held in this input
          this.prototype.centsValue = null;
  
          // How many cents are in the primary "unit" of the currency (i.e. 100 cents in 1 US Dollar)
          this.prototype.centsUnit = 1;
        }

        constructor(props) {
          super(props);
          this.UNSAFE_componentWillReceiveProps = this.UNSAFE_componentWillReceiveProps.bind(this);
          this.onInputChange = this.onInputChange.bind(this);
this._formatCentsValue = this._formatCentsValue.bind(this);

          // Look up currency details
          this.currency = currencyFormatter.findCurrency(props.currency.toUpperCase()) || currencyFormatter.findCurrency('USD');

          // Cents unit size (i.e. 100 cents = 1 dollar)
          this.centsUnit = Math.pow(10, this.currency.decimalDigits);

          this.dirty = false;
          this.centsValue = props.value || null;

          this.currencyMask = createNumberMask({
            prefix: '',
            suffix: '',
            thousandsSeparatorSymbol: this.currency.thousandsSeparator,
            decimalSymbol: this.currency.decimalSymbol,
            allowDecimal: true,
            decimalLimit: this.currency.decimalDigits,
            allowNegative: false,
            allowLeadingZeros: false
          });

          this.state = {
            placeholder: props.placeholderValue ? this._formatCentsValue(props.placeholderValue) : props.placeholder ? props.placeholder : this._formatCentsValue(0),
            // Initialize the input value to a formatted version of the value prop, unless it's blank
            inputValue: this.centsValue === null ? '' : this._formatCentsValue(this.centsValue)
          };
        }

        UNSAFE_componentWillReceiveProps(nextProps) {
          // Refresh cached currency
          if (nextProps.currency !== this.props.currency) {
            this.currency  = currencyFormatter.findCurrency(nextProps.currency.toUpperCase());
            this.centsUnit = Math.pow(10, this.currency.decimalDigits);
            this.setState({placeholder: this._formatCentsValue(0)});

            this.currencyMask = createNumberMask({
              prefix: '',
              suffix: '',
              thousandsSeparatorSymbol: this.currency.thousandsSeparator,
              decimalSymbol: this.currency.decimalSymbol,
              allowDecimal: true,
              decimalLimit: this.currency.decimalDigits,
              allowNegative: false,
              allowLeadingZeros: false
            });
          }

          // If we receive a new value prop that is actually different than the current input state, not just
          // different than the last value prop we received, then reset the internal state.
          //
          // Receiving a different value prop that doesn't *actually* change the input currency value is likely
          // just from an input handler above us.
          if ((nextProps.value !== this.props.value) && (nextProps.value !== this.centsValue)) {
            this.dirty = false;
            this.centsValue = nextProps.value;
            return this.setState({
              inputValue: this._formatCentsValue(nextProps.value)});
          }
        }


        // Delegate input change event to onChange prop, providing a numeric cents value, or an error
        onInputChange(event) {
          this.centsValue = event.target.value === '' ?
            null
          :
            Math.round(currencyFormatter.unformat(event.target.value, {code: this.currency.code}) * this.centsUnit);

          this.dirty = true;
          this.setState({
            inputValue: event.target.value});

          return this.props.onChange(event, this.centsValue);
        }

        render() {
          // Prepare the prefix/suffix for the currency symbol
          let prefix; let suffix;
          if (this.currency.symbolOnLeft) {
            prefix = this.currency.symbol;
            suffix = null;
          } else {
            prefix = null;
            suffix = this.currency.symbol;
          }

          const outerClasses = classNames('currency-input', this.props.className, {
            'currency-input-prefixed': !!prefix,
            'currency-input-suffixed': !!suffix
          }
          );

          const inputClasses = classNames('currency-input-value', {
            'currency-input-prefixed': !!prefix,
            'currency-input-suffixed': !!suffix
          }
          );


          return <span className={outerClasses}>
            {prefix && <span className="currency-input-prefix">{prefix}</span>}
            <MaskedInput type="text"
                         className={inputClasses}
                         name={this.props.name}
                         value={this.state.inputValue}
                         mask={this.currencyMask}
                         disabled={this.props.disabled}
                         placeholder={this.state.placeholder}
                         onChange={this.onInputChange}/>
            {suffix && <span className="currency-input-suffix">{suffix}</span>}
          </span>;
        }

        // Format +cents+ as a pretty value for the input, according to the currency's rules, without the currency symbol
        _formatCentsValue(cents) {
          return currencyFormatter.format(cents / this.centsUnit, {code: this.currency.code, symbol: ''});
        }
      }
CurrencyInput.initClass();